import styles from './external-access-layout.module.scss';
import jlllogo from 'img/jlllogo.png';
import { useTranslation } from 'react-i18next';

export default function ExternalAccessLayout(props) {
  const { children, description, showTitle = true } = props;
  const { t } = useTranslation();
  return (
    <div className={styles.container}>
      <div className={styles.column1}></div>
      <div className={styles.column2}>
        <div className={styles.column2__container}>
          <img className={styles.logo} alt="" src={jlllogo}></img>
          {showTitle && <div className={styles.title}>{t('externalAccess.title')}</div>}
          <div className={styles.description}>{description}</div>
        </div>
        {children}
      </div>
    </div>
  );
}
